/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface EnrichmentJobBody
 */
export interface EnrichmentJobBody  {
    /**
     * 
     * @type {number}
     * @memberof EnrichmentJobBody
     */
    chunkSize?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichmentJobBody
     */
    cursor?: string;
}

/**
 * Check if a given object implements the EnrichmentJobBody interface.
 */
export function instanceOfEnrichmentJobBody(value: object): value is EnrichmentJobBody {
    return true;
}

export function EnrichmentJobBodyFromJSON(json: any): EnrichmentJobBody {
    return EnrichmentJobBodyFromJSONTyped(json, false);
}

export function EnrichmentJobBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrichmentJobBody {
    if (json == null) {
        return json;
    }
    return {
        
                  'chunkSize': json['chunkSize'] == null ? undefined : json['chunkSize'],
                  'cursor': json['cursor'] == null ? undefined : json['cursor'],
    };
}

export function EnrichmentJobBodyToJSON(json: any): EnrichmentJobBody {
    return EnrichmentJobBodyToJSONTyped(json, false);
}

export function EnrichmentJobBodyToJSONTyped(value?: EnrichmentJobBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'chunkSize': value['chunkSize'],
        'cursor': value['cursor'],
    };
}


